import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ContactsService } from '../../../../../../../../core/lists';
import { ActivatedRoute, Router } from '@angular/router';
import { LayoutUtilsService } from '../../../../../../../../core/_base/crud';
import { Store } from '@ngrx/store';
import { AppState } from '../../../../../../../../core/reducers';
import { GeneralValidationMessagesService } from '../../../../../../../../core/services/general-validation-messages.service';

@Component({
  selector: 'kt-contact-history',
  templateUrl: './contact-login-history.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContactLoginHistoryComponent implements OnInit, OnDestroy {
  private subscriptions: any[] = [];
  contactId;
  contact;
  @Input() result;
  @Output() username = new EventEmitter<any>();
  loading = true;
  constructor(
    public dialog: MatDialog,
    private contactService: ContactsService,
    private router: Router,
    private layoutUtilsService: LayoutUtilsService,
    private store: Store<AppState>,
    private cdr: ChangeDetectorRef,
    private activateRoute: ActivatedRoute,
    private globalService: GeneralValidationMessagesService,
  ) {}

  ngOnInit() {
    this.activateRoute.params.subscribe((params) => {
      if (params.id)
        this.globalService.getEntitiesById('contacts', params.id).subscribe((res) => {
          if (res) {
            this.contact = res.data;
            this.loading = false;
            this.contactId = this.contact.id;
            this.cdr.detectChanges();
          }
        });
    });
  }

  ngOnDestroy() {
    this.subscriptions.forEach((el) => {
      if (el.sub) {
        el.sub.unsubscribe();
      }
    });
  }

  refresh() {
    this.contactService.getLoginHistory(this.contact.id).subscribe((res) => {
      this.result = res;
      this.username.emit(res.username);
      this.cdr.detectChanges();
    });
  }
}
